import React, { Fragment } from "react";
import { forceInt, packClasses } from "Utils";

const friendlyNames = {
    "*": "All Actions",
    create: "Create New",
    get: "View",
    list: "List and Search",
    delete: "Remove",
    update: "Edit All",
    publish: "Publish All",
    preview: "Preview",
    publish_type_article: "Publish Article",
    publish_type_media: "Publish Media",
    publish_type_page: "Publish Page",
    publish_type_post: "Publish Post",
    type_article: "Edit Article",
    type_media: "Edit Media",
    type_page: "Edit Page",
    type_post: "Edit Post",
    priority: "Change Priority",
    restore: "Restore Version",
    lock: "Manage Locks",
    pull: "Update from Print",
    push: "Update to Print",
    unlock: "Manage Locks on Behalf of Others",
    version: "Restore Version",
    versions: "View Version History",
};

const toFriendlyName = function (resource) {
    if (friendlyNames[resource]) {
        return friendlyNames[resource];
    }

    return resource;
};

export default function GroupSelector(props) {
    const { role, resource, currentRole, updateRole } = props;

    const isEnabled = (acl, resource) => {
        if (!currentRole || !currentRole?.accesses) {
            return null;
        }

        if (
            !currentRole.accesses.hasOwnProperty(acl) ||
            !currentRole.accesses[acl].hasOwnProperty(resource)
        ) {
            return null;
        }
        return forceInt(currentRole?.accesses[acl][resource]);
    };

    return (
        <Fragment>
            <tr
                className={packClasses(
                    "border-t odd:border-gray-200 even:border-gray-300",
                    props.hidden ? "hidden" : ""
                )}
            >
                <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm text-gray-900 sm:pl-6">
                    {toFriendlyName(resource)}
                </td>
                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    {isEnabled(role, resource) === 1 && (
                        <button
                            type="button"
                            className="text-green-600"
                            onClick={() => updateRole(role, resource, 0)}
                        >
                            {" "}
                            Allowed
                        </button>
                    )}
                    {isEnabled(role, resource) === 0 && (
                        <button
                            type="button"
                            className="text-red-600"
                            onClick={() => updateRole(role, resource, null)}
                        >
                            {" "}
                            Denied
                        </button>
                    )}
                    {isEnabled(role, resource) === null && (
                        <button
                            type="button"
                            className="text-gray-500"
                            onClick={() => updateRole(role, resource, 1)}
                        >
                            {" "}
                            Not set
                        </button>
                    )}
                </td>
            </tr>
        </Fragment>
    );
}
